import autoImage from "@gqlapp/base/Image/autoImage";

export const getMaxMin = (large: number, small: number) => {
	const max = Math.round((large - small)/2);
	const min = -(max);
	let pecentMin = 50 - (max/large) * 100;
	let pecentMax = 50 + (max/large) * 100;

	return [max, min, pecentMax, pecentMin ]
}


export const getAttribute = ([pw, ph]: number[], width: number, height: number) =>{
	let propsX: number[] = ([pw, width].sort((a, b)=> (b-a)));
	let propsY: number[] = ([ph, height].sort((a, b)=> (b-a)));
	// @ts-ignore
	let [maxX, minX, pMaxX, pMinX] = getMaxMin(...propsX);
	// @ts-ignore
	let [maxY, minY, pMaxY, pMinY] = getMaxMin(...propsY);

	return [[maxX, minX, maxY, minY], [pMaxX, pMinX, pMaxY, pMinY]];
}


// Hàm clamp để giới hạn giá trị
export function clamp(value:number, min:number, max:number) {
	return Math.max(min, Math.min(max, value));
}



export function getPoint([bw, bh ]: number[], [w, h]: number[], { x, y}: any){
	const [[], [maxX, minX, maxY, minY]]= getAttribute([bw, bh], w, h);
	x = getPos(x, minX, maxX);
	y = getPos(y, minY, maxY);
	return [bw * x/100 - w/2, bh * y/100 - h/2]
}


export function getPos(pos: number, min: number, max: number){
	if(pos > max){
		pos = max;
	}else if(pos < min){
		pos = min;
	}
	
	return pos;
}

/**
 *
 * @param preview
 * @param x
 * @param y
 * @param width
 * @param height
 * @param props
 */
export function clamped(preview: number[], { x, y, width, height, ...props}: any){
	const [[], [maxX, minX, maxY, minY]]= getAttribute(preview, width, height);
	x = getPos(x, minX, maxX);
	y = getPos(y, minY, maxY);
	return { ...props, x, y, preview, width, height }
}



/**
 * @param preview
 *		preview khung ngoài của hình ảnh*
 * @param state
 * 		pointX, pointY là điểm bắt đầu click chuột,
 * 		top, left là khoảng bắt đầu click chuột so với preview
 *
 * @param width
 * 		width là độ rộng của ảnh nhỏ
 * @param height
 * 		height là triều cao của ảnh nhỏ
 */
export function dataMap(preview: number[], { state, width, height }){
	const [[ maxX, minX, maxY, minY]] = getAttribute(preview, width, height);
	let [pw, ph] = preview;

	/*** khoảng tới của chuột */
	return function map({ top, left }){
		let deltaX = state.pointX + (left - state?.left) * pw;
		let deltaY = state.pointY + (top - state?.top) * ph;

		const clampedX = clamp(deltaX, minX, maxX);
		const clampedY = clamp(deltaY, minY, maxY);

		let x: number = 50 - (100 * (clampedX / width));
		let y: number = 50 - (100 * (clampedY / height));

		return { x, y, deltaX, deltaY, clampedX, clampedY, top, left }
	}
}


/**
 *
 * @param zoom
 * @param wrapWidth
 * @param wrapHeight
 * @param width
 * @param height
 * @param bgWidth
 * @param bgHeight
 */
export function getImage(zoom: number, [wrapWidth, wrapHeight]: number[], [width, height]:number[], [bgWidth, bgHeight]:number[]){
	zoom = zoom || 1;

	let preview = autoImage(`${wrapWidth}:${wrapHeight}`, bgWidth, bgHeight)
	let [maxWidth, maxHeight] = preview;
	let [mw, mh] = autoImage(`${maxWidth}:${maxHeight}`, width, height)
	width = mw * (1/zoom); height= mh * (1/zoom);

	return { width, height, preview, maxWidth, maxHeight, mw, mh}
}